/**
 * 
 */
;
(function(window, undefined) {
	"use strict";
	angular.module("cbl.insuranceloanpmi.mf").service("CreasFunaSrvc",
			[ '$http', '$q', 'CreasMessaggiFctr', 'LabelSrvc', 'LoggerSrvc', 'CONSTANTS', function($http, $q, messaggiFctr, labelSrvc, loggerSrvc, CONSTANTS) {
				// Esempio Driver
				this.driverFuna = {
					codForm : null,
					codAttivita : null,
					codAttributo : null,
					codStato : null,
					accessoFunzione : null,
					flRichiamato : null
				};

				this.openConfirm = false;
				this.confirmText = "";
				this.angForm = {};
				this.sottomesso = false;
				this.inEsecuzione = false;

				this.funaList = [];
				this.funaMap = {};

				this.executePreRelease = function(funa, params) {
				};
				this.executePostRelease = function(funa, fromPre) {
				};
				this.messagesConfirm = function(funa) {
				};

				this.setUpFuna = function(angForm, form, accesso, executePreRelease, executePostRelease, messagesConfirm, task, level) {

					this.reset(level);

					var defer = $q.defer();
					var driverFuna = {
						codForm : form,
						codAttivita : task ? task.codAttivita : null,
						flRichiamato : (task && task.richiamato !== null) ? task.richiamato === '1' : null,
						codStato : task ? task.stato : null,
						codAttributo : task ? task.attributo : null,
						accessoFunzione : accesso
					}

					var funaTask = {
						codAttivita : task.codAttivita,
						codProcesso : task.codProcesso,
						idAttivita : task.idAttivita,
						idTecnico : task.id
					};
					this.angForm = angForm;
					this.openConfirm = false;
					this.funaList[level] = [];
					executePreRelease = executePreRelease && typeof executePreRelease === "function" ? executePreRelease : this.executePreRelease;
					executePostRelease = executePostRelease && typeof executePostRelease === "function" ? executePostRelease : this.executePostRelease;
					messagesConfirm = messagesConfirm && typeof messagesConfirm === "function" ? messagesConfirm : this.messagesConfirm;

					var self = this;
					$http({
						method : "POST",
						url : CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.FUNA,
						data : driverFuna
					}).then(function(response) {
						if (messaggiFctr.processaResponse(response)) {
							return;
						}
						self.funaList[level] = response.data.result;
						for ( var i in self.funaList[level]) {
							self.funaList[level][i].task = funaTask;
							if (self.hasFunction(self.funaList[level][i].codice)) {
								// ERRORE!!!
								messaggiFctr.addMessage({
									type : "E",
									message : "Funzione duplicata! (" + self.funaList[level][i].codice + ")"
								});
								defer.reject(false);
								return;
							}
							self.funaList[level][i]["bean"] = {
								angForm : angForm,
								executePreRelease : executePreRelease,
								executePostRelease : executePostRelease,
								messagesConfirm : messagesConfirm
							}
							self.funaMap[self.funaList[level][i].codice] = self.funaList[level][i];
						}
						defer.resolve(true);
					}, function(reason) {
						messaggiFctr.processaResponse(reason);
						defer.resolve(false);
					});
					return defer.promise;
				};

				this.executeFuna = function(funa) {
					this.annullaFuna();
					this.sottomesso = true;
					messaggiFctr.resetMessages();
					if (!funa.noCheck && !messaggiFctr.processaForm(funa.bean.angForm)) {
						return;
					}

					if (funa.noCheck && !messaggiFctr.validaForm(funa.bean.angForm)) {
						return;
					}

					var params = {
						causale : "",
						pagamenti : [],
						params : []
					};
					var funaSelf = this;
					try {
						funaSelf.inEsecuzione = true;
						var fromPre = funa.bean.executePreRelease(funa, params);
						if (!fromPre) {
							fromPre = $q.when("");
						}
						fromPre.then(function(response) {
							var deferred = $q.defer();
							if (funa.outcome && funa.outcome.cod && funa.outcome.cod !== '') {
								funa.task.esito = funa.outcome.cod;
								funa.task.causale = params.causale;
								funa.task.pagamenti = params.pagamenti;
								$http({
									method : "POST",
									url : CONSTANTS.REST_ROOT + CONSTANTS.REST.WORKFLOW.TASK_EXECUTE,
									data : funa.task
								}).then(function(response) {
									if (messaggiFctr.processaResponse(response)) {
										deferred.reject("Errore registrato nel rilascio task");
										return;
									}
									funa.task.id = response.data.result;
									deferred.resolve(true);
								}, function(reason) {
									messaggiFctr.processaResponse(reason);
									deferred.reject("Errore (non registrato) nel rilascio task. Status chiamata: " + JSON.stringify(reason));
								});
							} else {
								deferred.resolve(true);
							}
							deferred.promise.then(function(funaResponse) {
								var fromPost = funa.bean.executePostRelease(funa, response);
								if (!fromPost) {
									fromPost = $q.when("");
								}
								fromPost.then(function(postResponse) {
									// END funa
									funaSelf.inEsecuzione = false;
								}, function(reason) {
									var e = {
										message : funa.codice + ": funzione post rilascio fallita! Errore: " + reason
									};
									loggerSrvc.log("CreasFunaSrvc", loggerSrvc.SEVERE, e.message);
									funaSelf.inEsecuzione = false;
									throw e;
								})
							}, function(reason) {
								var e = {
									message : funa.codice + ": rilascio task con esito [" + funa.outcome.cod + "] fallito! Errore: " + reason
								};
								loggerSrvc.log("CreasFunaSrvc", loggerSrvc.SEVERE, e.message);
								funaSelf.inEsecuzione = false;
								throw e;
							})
						}, function(reason) {
							var e = {
								message : funa.codice + ": funzione pre rilascio fallita! Errore: " + reason
							};
							loggerSrvc.log("CreasFunaSrvc", loggerSrvc.SEVERE, e.message);
							funaSelf.inEsecuzione = false;
							throw e;
						})

					} catch (e) {
						loggerSrvc.log("CreasFunaSrvc", loggerSrvc.SEVERE, e.message);
						funaSelf.inEsecuzione = false;
					}
				};

				this.openConfirmFuna = function(funa) {
					this.openConfirm = funa;
					this.sottomesso = true;
					messaggiFctr.resetMessages();
					if (funa.noCheck && messaggiFctr.processaForm(funa.bean.angForm)) {
						return;
					}
					if (!funa.noCheck && messaggiFctr.validaForm(funa.bean.angForm)) {
						return;
					}
					this.confirmText = funa.bean.messagesConfirm(funa);
					if (!this.confirmText) {
						this.confirmText = labelSrvc.getLabel("funa.confirm.default");
					}
					angular.element("#funaModal").modal("show");
				};

				this.hasFunction = function(codice) {
					return this.funaMap.hasOwnProperty(codice); // this.funaMap[codice] != null && this.funaMap[codice] != undefined;
				};

				this.executeButtonFuna = function(codice) {
					return this.executeFuna(this.funaMap[codice]);
				};

				this.annullaFuna = function() {
					this.openConfirm = false;
					angular.element("#funaModal").modal("hide");
				};

				this.getFunzioni = function() {
					var funcArray = [];
					for ( var i in this.funaList) {
						funcArray = funcArray.concat(this.funaList[i]);
					}
					return funcArray;
				};

				this.reset = function(level) {
					this.sottomesso = false;
					if (!level) {
						level = 0;
					}
					if (!this.funaList) {
						// Service non ancora inizializzato
						this.funaList = [];
						return;
					}
					if (this.funaList.length < level) {
						// Il livello non è presente
						return;
					}
					this.funaList.splice((level), (this.funaList.length - level));
					// Reset della mappa sulle liste rimaste
					this.funaMap = {};
					for ( var i in this.funaList) {
						var funaList = this.funaList[i];
						for ( var j in funaList) {
							this.funaMap[funaList[j].codice] = funaList[j];
						}
					}
				}

			} ]);
}(window));


//////////////////
// WEBPACK FOOTER
// ./app/widgets/creasFuna/creasFunaSrvc.js
// module id = 6
// module chunks = 0 1